import React from 'react'
import { Modal } from '@enamelai/design-system'

type FilesDeleteConfirmModalProps = {
  show: boolean
  itemName: string
  itemKind?: 'file' | 'folder'
  onCancel: () => void
  onDelete: () => void
}

const FilesDeleteConfirmModal: React.FC<FilesDeleteConfirmModalProps> = ({
  show,
  itemName,
  itemKind = 'file',
  onCancel,
  onDelete,
}) => {
  const name = itemName.trim() || `this ${itemKind}`

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title={itemKind === 'folder' ? 'Delete folder' : 'Delete file'}
      description={`Are you sure you want to delete ${name}? This action can't be undone.`}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      onPrimaryClick={onDelete}
      onSecondaryClick={onCancel}
    />
  )
}

export default FilesDeleteConfirmModal
